import * as React from "react";
import IconLocation from "@material-ui/icons/LocationOnOutlined";
import { ReactComponent as IconCompare } from "../../../../assets/img/icons/swap-icon.svg";
import AutoComplete from "../../AutoCompleteAirport";
import "../index.css";

import classes from "./OriginDestInput.module.css";

export default function OriginDestination(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [arrivalAirportName, setArrivalAirportName] = React.useState(null);
  const [departureAirportName, setDepartureAirportName] = React.useState(null);

  React.useEffect(() => {
    setDepartureAirportName(props.origin?.name);
    setArrivalAirportName(props.destination?.name);
  }, [props.origin, props.destination]);

  const handleOriginChange = (value) => {
    if (value && value.code) {
      return props?.onOriginChange(value);
    }
  };

  const handleDestinationChange = (value) => {
    if (value && value.code) {
      return props?.onDestinationChange(value);
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className="row">
      <div className={`${classes["origin-dest-input"]} ${classes.origin}`}>
        <div style={{ textAlign: "left", color: "var(--darker)" }}>
          <div
            className="inline-block origin-name"
            style={{ padding: "0.5rem 1rem" }}
          >
            <AutoComplete
              fullWidth
              text={departureAirportName}
              id="outlined-basic"
              placeholder="From"
              onChange={handleOriginChange}
            />
          </div>
        </div>
        <div className={classes["compare-icon"]}>
          <IconCompare />
        </div>
      </div>
      <div className={classes["origin-dest-input"]}>
        <div style={{ textAlign: "left", color: "var(--darker)" }}>
          <div
            className="inline-block destination-name"
            style={{ padding: "0.5rem 1rem" }}
          >
            <AutoComplete
              fullWidth
              text={arrivalAirportName}
              id="outlined-basic"
              placeholder="To"
              onChange={handleDestinationChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
